// extracted by mini-css-extract-plugin
export default {"root":"PlaylistMarkdownRenderer_root__-kkr+"};